import { Component, OnInit, ViewChild } from "@angular/core";
import { FormControl, FormGroup, NgForm, Validators } from "@angular/forms";
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { Router } from "@angular/router";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MasterService } from "src/app/services/master.service";
import { Page } from "src/app/model/Page";
import { FeatureResponseModel } from "src/app/model/FeatureResponseModel";
import { MatDialog } from "@angular/material/dialog";

@Component({
  selector: "app-secure-payment-refund-upload",
  templateUrl: "./payment-refund-upload.component.html",
  styleUrls: ["./payment-refund-upload.component.scss"],
})
export class PaymentRefundUploadComponent implements OnInit {
  loaded: boolean = false;
  page: Page<FeatureResponseModel>;
  dataSource: MatTableDataSource<FeatureResponseModel> =
    new MatTableDataSource();
  pageSizeOptions: number[] = [10, 25, 100];
  isLoading = false;
  totalRows = 0;
  pageSize = 10;
  currentPage = 0;
  selectedFile: File;
  showDataHere: any = "";
  @ViewChild("localForm") localForm: NgForm;
  form: FormGroup = new FormGroup({});
  isSearchDisabled: boolean = false;
  isSubmitDisabled: boolean = false;
  displayedColumns: string[] = [
    "id",
    "fileName",
    // "subject",
    // "emailSmsBody",
    "startTime",
    "endTime",
    "status",
    "count",
    // "displayOrder",
    "action",
  ];
  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(
    public dialog: MatDialog,
    private masterService: MasterService,
    private router: Router,
    private _snackBar: MatSnackBar
  ) {}

  ngOnInit(): void {
    this.form = new FormGroup({
      emailSmsBody: new FormControl(null, Validators.required),
      subject: new FormControl(null, Validators.required),
      email: new FormControl(),
      sms: new FormControl(),
      notification: new FormControl(),
      finalmessage: new FormControl(),
      showDataHere: new FormControl(),
      file: new FormControl(),
      csvcolume: new FormControl(),
    });
    this.loadData();
  }

  resetFilter() {
    // this.filterForm.controls["filterText"].setValue(null);
    this.loadData();
  }
  onFileSelect(event) {
    this.selectedFile = event.target.files[0];
    let reader: FileReader = new FileReader();
    reader.readAsText(this.selectedFile);

    reader.onload = (e) => {
      let csv: string = reader.result as string;
      let allTextLines = csv.split(/\r|\n|\r/);
      let headers = allTextLines[0].split(",");
      let lines = [];

      for (let i = 0; i < allTextLines.length; i++) {
        // split content based on comma
        let data = allTextLines[i].split(",");

        if (data.length === headers.length) {
          let tarr = [];
          for (let j = 0; j < headers.length; j++) {
            tarr.push(data[j]);
          }

          // log each row to see output
          console.log(tarr);
          lines.push(tarr);
        }
      }

      this.showDataHere = lines[0].join("\n");
      if (
        this.showDataHere.includes("APPLICATION_No")
        //  ||
        // this.showDataHere.includes("Pan No")
      ) {
        this.showDataHere;
      } else {
        this.errorToast("APPLICATION_No will be Compulsory in CSV file");
        this.localForm.resetForm({
          file: null,
        });
        this.selectedFile = null;
        this.showDataHere = null;
      }
    };
  }
  async errorToast(errorMessage: string, dur?: number) {
    await this._snackBar.open(errorMessage, "Close", {
      horizontalPosition: "right",
      verticalPosition: "top",
      panelClass: "error-toast",
      duration: dur ? dur : 3 * 1000,
    });
  }
  downloadPaymentRefundTemplate() {
    this.masterService
      .downloadPaymentRefundTemplate()
      .subscribe((data: any) => {
        if (data.status === "SUCCESS") {
          this.downloadFile1(data.data, "PAYMENTREFUND.csv");
        } else {
          this.masterService.errorToast(data.errorMessage);
        }
      });
  }
  loadData() {
    this.masterService
      .getPaymentRefundUploadFileList(
        this.currentPage,
        this.pageSize,
        this.form.value.filterText
      )
      .subscribe(
        (page: any) => {
          this.loaded = true;
          this.page = page;
          this.dataSource = new MatTableDataSource(page.content);
          setTimeout(() => {
            // this.paginator.pageIndex = this.currentPage;
            // this.paginator.length = page.totalElements;
          });
          this.isSearchDisabled = false;
        },
        (error) => {
          console.log(error);
          this.isLoading = false;
          this.isSearchDisabled = false;
        }
      );
  }
  pageChanged(event: PageEvent) {
    console.log({ event });
    this.pageSize = event.pageSize;
    this.currentPage = event.pageIndex;
    this.loadData();
  }

  download(key: number) {
    this.isLoading = true;
    console.log("keyyyyy", key);
    this.masterService.downloadPaymentRefundFile(key).subscribe(
      (data) => {
        this.isSubmitDisabled = false;
        this.isLoading = false;
        if (data.status === "SUCCESS") {
          this.downloadFile(data.base64File, data.fileName);
        } else {
          this.masterService.errorToast(data.errorMessage);
        }
      },
      (error) => {
        this.isLoading = false;
        this.isSubmitDisabled = false;
        this.masterService.errorToast(
          error?.error?.message ||
            error?.errorMessage ||
            error?.error?.errorMessage
        );
      }
    );
  }
  downloadUpFile(key: number) {
    this.masterService.downloadPaymentRefundUploadFile(key).subscribe(
      (data: any) => {
        console.log("data++++++++++++++++", data);
        if (data.status === "SUCCESS") {
          this.downloadFile1(data.data, data.fileName);
        } else {
          this.masterService.errorToast(data.errorMessage);
        }
      },
      (error) => {
        this.isLoading = false;
        this.isSubmitDisabled = false;
        this.masterService.errorToast(
          error?.error?.message ||
            error?.errorMessage ||
            error?.error?.errorMessage
        );
      }
    );
  }

  downloadFile(base64: string | ArrayBuffer, fileName: string) {
    const src = `${base64}`;
    const link = document.createElement("a");
    link.href = src;
    link.download = fileName;
    link.click();

    link.remove();
  }
  downloadFile1(base64: string | ArrayBuffer, fileName: string) {
    const src = `data:text/csv;base64,${base64}`;
    const link = document.createElement("a");
    link.href = src;
    link.download = fileName;
    link.click();

    link.remove();
  }

  onSubmit() {
    console.log(this.selectedFile);

    if (this.selectedFile) {
      this.isLoading = true;
      const reader = new FileReader();
      reader.readAsDataURL(this.selectedFile);
      reader.onload = () => {
        this.masterService
          .finalBulkPaymentRefundResults(
            reader.result,
            this.selectedFile.name.substring(
              0,
              this.selectedFile.name.indexOf(".")
            )
          )
          .subscribe(
            (data: any) => {
              this.isSubmitDisabled = false;
              if (data.status === "SUCCESS") {
                this.isLoading = true;
                this.successOnsubmitToast();
                this.localForm.resetForm({
                  file: null,
                });
                this.selectedFile = null;
                this.showDataHere = null;
                // window.onload;
                location.reload();
              } else {
                this.isLoading = true;
                this.localForm.resetForm({
                  file: null,
                });
                this.selectedFile = null;
                this.masterService.errorToast(data.errorMessage);
              }
            },
            (error) => {
              this.isLoading = false;
              this.localForm.resetForm({
                file: null,
              });
              this.selectedFile = null;
              this.showDataHere = null;
              this.isSubmitDisabled = false;
              console.log(error);

              this.masterService.errorToast(
                error?.error?.message || error?.error?.errorMessage,
                5 * 1000
              );
            }
          );
      };
    } else {
      this.masterService.errorToast("Please upload file ");
    }
  }
  async successOnsubmitToast() {
    await this._snackBar.open("Job Excution Start", "Close", {
      horizontalPosition: "right",
      verticalPosition: "top",
      panelClass: "success-toast",
      duration: 3 * 1000,
    });
  }
}
